/**
 * Company routes. All are tenant-scoped (slug-bearing) and authenticated —
 * the list links to the profile, and the profile reads its tenant from the
 * URL slug. (epic 107, tickets/2465)
 */
export default [
  {
    component: () => import('../pages/companyList.vue'),
    name: 'companies.list',
    path: '/:slug/companies',
    meta: { title: 'Companies — Venture360' },
  },
  {
    // Static segment outranks `:companyId` in vue-router, so this never
    // collides with the profile route (ids are numeric anyway).
    component: () => import('../pages/companyOnboarding.vue'),
    name: 'companies.onboarding',
    path: '/:slug/companies/new',
    meta: { title: 'Create Company — Venture360' },
  },
  {
    component: () => import('../pages/[companyId].vue'),
    name: 'companies.profile',
    path: '/:slug/companies/:companyId',
    meta: { title: 'Company — Venture360' },
  },
  {
    component: () => import('../pages/[companyId]/activities/index.vue'),
    name: 'companies.activity',
    path: '/:slug/companies/:companyId/activities',
    meta: { title: 'Company — Venture360' },
  },
  {
    // Company discussions thread (tickets/2589) — reuses the shared notes
    // subsystem (Comment model + investing v4 notes API + NoteTimeline).
    component: () => import('../pages/[companyId]/discussions.vue'),
    name: 'companies.discussions',
    path: '/:slug/companies/:companyId/discussions',
    meta: { title: 'Company — Venture360' },
  },
  {
    // Edit reuses the create wizard component (dual-mode, tickets/2670) — the
    // page branches on the route name. Same SPV/Fund pattern.
    component: () => import('../pages/companyOnboarding.vue'),
    name: 'companies.edit',
    path: '/:slug/companies/:companyId/edit',
    meta: { title: 'Edit Company — Venture360' },
  },
  {
    // Company files page (epic 109, tickets/2746) — the company becomes a
    // fileable; the tab links here from the profile shell.
    component: () => import('../pages/[companyId]/files.vue'),
    name: 'companies.files',
    path: '/:slug/companies/:companyId/files',
    meta: { title: 'Company Files — Venture360', migratedDesign: true },
  },
  {
    component: () => import('../pages/[companyId]/term-sheet/[termSheetId]/files.vue'),
    name: 'companies.term_sheet_files',
    path: '/:slug/companies/:companyId/term-sheet/:termSheetId/files',
    meta: { title: 'Class Documents — Venture360', migratedDesign: true },
  },
  {
    component: () => import('../pages/[companyId]/account/index.vue'),
    name: 'companies.account',
    path: '/:slug/companies/:companyId/account',
    meta: { title: 'Account — Venture360' },
  },
]
